import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit'
import { taskExtraReducers } from '@store/reducres/task.reducers'
import { AppState } from '@store/slices/generic.slice'
import { RootState } from '@store/store'
import { TaskResult } from '@shared/classes'

export const taskUrl = 'task/'

export interface TaskModel {
  id: EntityId
  started?: string
  stopped?: string
  success?: boolean
  title: string
  relatedObjects: { entityName: string; entityIds: EntityId[] }[]
  relatedLink?: string
  result?: TaskResult
}

export interface TaskState extends AppState<TaskModel> {
  runningTaskIds: EntityId[]
  unresolvedTaskIds: EntityId[]
}

// Create the entity adapter for tasks
const TasksAdapter = createEntityAdapter<TaskModel>()

export const TasksAdapterExport = TasksAdapter

// Initial state using the adapter's getInitialState()
const initialState: TaskState = {
  ...TasksAdapter.getInitialState(),
  runningTaskIds: [],
  unresolvedTaskIds: [],
  loading: false,
  inProgress: [],
  error: null,
}

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    taskExtraReducers(builder)
  },
})

export const selectTask = (state: RootState) => state.task

// Export adapter selectors
export const { selectAll: selectAllTasks } = TasksAdapter.getSelectors(
  (state: { task: TaskState }) => state.task
)

export default taskSlice.reducer
